/**
 * First we will load all of this project's JavaScript dependencies.
 */

require('./bootstrap');

$(document).ready(function () {
    $('.js__brands-checkbox').click(function () {
        let dataId = $(this).data('brand-id');
        let urlInputSelector = $('.js__' + dataId);

        if (urlInputSelector.hasClass('hidden')) {
            urlInputSelector.val('');
        }

        urlInputSelector.toggleClass('hidden');
    });

    if ($('form#polymer-config-form').length > 0) {
        require('./polymer-config');
    }

    // toggle display of additional info of translations in Translation manager overview
    let toggleDisplayUl = $('.js__toggle-display-block');
    if (toggleDisplayUl.length > 0) {
        $('.js__toggle-display-blocks-button').click(function () {
            toggleDisplayUl.each(function (i, obj) {
                if ($(obj).css('display') === 'none') {
                    $(obj).css('display', 'block');
                } else {
                    $(obj).css('display', 'none');
                }
            });
        });
    }
    
    $('td.js__toggle-display-row').click(function () {
        let obj = $(this).closest('td').next('td').find('.js__toggle-display-block');
        if(obj.css('display') === 'none') {
            obj.css('display', 'block');
        } else {
            obj.css('display', 'none');
        }
    });

    $(".checkbox").change(function(){
        $attrName = $(this).attr('data-name');
       
        var new_length = (this.checked===true) ? $('.'+$attrName).length -  1 : $('.'+$attrName).length -  2
       
        if ($('.'+$attrName+':checked').length == new_length ) {
            $('#' + $attrName).prop('checked', true);
        }else{
            $('#' + $attrName).prop('checked', false);
        }
    });
    
    $('.parent').click(function (event) {
        var $attrName = $(this).attr('data-name');
        if (this.checked) {
            $('.' + $attrName).each(function () { 
                $(this).prop('checked', true);
            });
           
        } else {
            $('.' + $attrName).each(function () {
                $(this).prop('checked', false);            
            });

        }
    }); 


});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js